import { takeLatest, put, call } from 'redux-saga/effects';

import {
  passwordRecoveryRequest,
  passwordRecoveryFail,
  passwordRecoverySuccess,
  resendPasswordRecoveryRequest,
  resendPasswordRecoverySuccess,
  resendPasswordRecoveryFail,
  passwordResetRequest,
  passwordResetSuccess,
  passwordResetFail,
} from './actions';
import PasswordRecoveryService from '../../../services/PasswordRecoveryService';
import { getErrorMessage } from "../../util";


function* requestPasswordRecovery({ payload }: ReturnType<typeof passwordRecoveryRequest>) {
  try {
    yield call(PasswordRecoveryService.recover, payload);
    yield put(passwordRecoverySuccess());
  } catch (e) {
    yield put(passwordRecoveryFail(getErrorMessage(e)));
  }
}

function* resendEmail({ payload }: ReturnType<typeof resendPasswordRecoveryRequest>) {
  try {
    yield call(PasswordRecoveryService.resend, payload);
    yield put(resendPasswordRecoverySuccess());
  } catch (e) {
    yield put(resendPasswordRecoveryFail(getErrorMessage(e)));
  }
}

function* requestPasswordReset({ payload }: ReturnType<typeof passwordResetRequest>) {
  try {
    yield call(PasswordRecoveryService.reset, payload);
    yield put(passwordResetSuccess());
  } catch (e) {
    yield put(passwordResetFail(getErrorMessage(e)));
  }
}

export default [
  takeLatest(passwordRecoveryRequest.type, requestPasswordRecovery),
  takeLatest(resendPasswordRecoveryRequest.type, resendEmail),
  takeLatest(passwordResetRequest.type, requestPasswordReset),
];
